module.exports = "/packs/media/digitalized_orders/market-7dff3912.png";